class StoreSwitcher extends HTMLElement {
  constructor() {
    super();
    this.storeConfig = this.querySelector('#Store-switcher-config') && JSON.parse(document.querySelector('#Store-switcher-config').innerHTML);
    this.currentCountry = this.storeConfig.current_store.iso_code;
    this.availableStores = this.storeConfig.available_stores;
    this.currentLocation = new URL(window.location.href);

    this.COUNTRYDRAWER = document.querySelector('dra-wer#Modal-storeswitcher');
    this.changeModeBtns = this.querySelectorAll('button[data-set-mode]');

    this.CONFIG = {
      storageNameForLocationPreference: "wasAskedForCountrySwitch",
      searchParamForRedirectedUser: "wasRedirected", /* e.g. ?[param] = US */
    };
  }

  get userLocationPreference() {
    return sessionStorage.getItem(this.CONFIG.storageNameForLocationPreference);
  }

  set userLocationPreference(countryLocationIsoCode) {
    sessionStorage.setItem(this.CONFIG.storageNameForLocationPreference, countryLocationIsoCode);
  }

  get userIsFromRedirect() {
    return this.currentLocation.searchParams.has(this.CONFIG.searchParamForRedirectedUser);
  }

  get userHasLocationPreference() {
    return !!this.userLocationPreference;
  }


  get shouldAutoRedirect() {
    if (!this.userIsFromRedirect) {
      let specialParamValues = ["QR", "insta-fb-abc", "linktree"];
      
      if (this.currentLocation.searchParams.has('utm_source')) {
        if (specialParamValues.indexOf(this.currentLocation.searchParams.get('utm_source')) > -1) {
          return true;
        }
      }
    }
    
    return;
  }

  promptUserToSwitchCountry(recommendationMode, recommendation_iso) {
    this.COUNTRYDRAWER.openDrawer();
    
    if (recommendationMode) {
      this._setMode('recommendation', recommendation_iso);
    }
  }
  
  autoRedirect() {
    this.redirectTo(this.USER_COUNTRY_CODE);
  }

  async checkUserSession() {
    /* no reason to popup if has preferencer OR already was redirected */
    if (this.userHasLocationPreference) {
      return;
    } 
      
    if (this.userIsFromRedirect) {
     this.userLocationPreference = 'wasRedirected';
     return;
    }
    
    await this.getUserLocation();

    /* if user is already on the matching currentCountry, do nothing */
    if (this.currentCountry === this.USER_COUNTRY_CODE) {
      return;  
    }
    
    if (this.shouldAutoRedirect) {
      this.autoRedirect();
      return;
    }

    /* current situation:
    - user has no preference
    - we should not redirect automatically
    - was not redirected
    - AND their country didn't match the @currentStore 
    */
    
    /* now: Check if we have a better suited country than the existing...."); */
    this.userLocationPreference = 'wasPrompted';
    
    if (this.currentStoreHasCountry || this.otherStoresHasCountry) {
      this.promptUserToSwitchCountry(true, this.USER_COUNTRY_CODE);
    }
  }

  get currentStoreHasCountry() {
    return this.storeConfig.current_store.countries_available_on_store.indexOf(this.USER_COUNTRY_CODE) > -1;
  }

  get otherStoresHasCountry() {
    return !!this.availableStores[this.USER_COUNTRY_CODE];
  }

  async getUserLocation() {
    try {
      return await fetch("https://ipapi.co/json").then((res) => {
        return res.json();
      }).then((resJSON) => {
        this.USER_COUNTRY_CODE = resJSON.country_code;
      });
    } catch (e) {
      console.log(e);
    }
    return false;
  }

  redirectTo(isoCode) {
    if (this.storeConfig.current_store.countries_available_on_store.indexOf(isoCode) > -1) {
      this.currentLocation.searchParams.set("country", isoCode);
      window.location.href = this.currentLocation.href;
      return;
    }

    /* we have nothing to do or recommend here... :) */
    if (!this.availableStores[isoCode]) {
      return;
    }
    
    let MATCHING_HREFLANG = this.availableStores[isoCode].region_w_langcode;
    
    /* look in hreflang tags in DOM */
    let redirectURL = document.querySelector('[hreflang="' + MATCHING_HREFLANG + '"]')?.getAttribute('href');

    /* none found in hreflang tags in DOM */
    if (!redirectURL) {
      redirectURL = this.availableStores[isoCode].root_url;
    }

    if (redirectURL) {
      let redirectURLObject = new URL(redirectURL);
      redirectURLObject.searchParams.set(this.CONFIG.searchParamForRedirectedUser, "true");
      redirectURLObject.searchParams.set('country', isoCode);

        window.location.href = redirectURLObject.href;
    }
  }

  listenForUserInteractions() {
    this._listenForChangeModeInteractions();
  }

  _setMode(modeStr, iso_code) {
    this.setAttribute('data-mode', modeStr);
    
    if (iso_code) {
      this.querySelector('[data-recommended-country]').appendChild(this.querySelector('store-switcher-btn[iso-code="' + iso_code +'"]').cloneNode(true));
    }
  }

  _listenForChangeModeInteractions() {
    this.changeModeBtns.forEach((elem) => {
      elem.addEventListener('click', () => {
        this._setMode(this.getAttribute('data-set-mode'));
      });
    });
  }

  connectedCallback() {
    this.listenForUserInteractions();
    this.checkUserSession();

    this.addEventListener('store-switcher:redirect', e => this.redirectTo(e.detail.iso_code));
  }
}

class StoreSwitcherBtn extends HTMLElement {
  constructor() {
    super();

    this.associatedStoreSwitcher = this.closest('store-switcher');
  }

  get isoCode() {
    return this.getAttribute('iso-code');
  }

  sendRedirectEvent() {
    this.dispatchEvent(new CustomEvent('store-switcher:redirect', {
      bubbles: true,
      detail: {
        iso_code: this.isoCode,
      },
    }));
  }

  connectedCallback() {
    this.addEventListener('click', this.sendRedirectEvent.bind(this));
  }
}

customElements.define('store-switcher', StoreSwitcher);
customElements.define('store-switcher-btn', StoreSwitcherBtn);